import FormGroup from "./FormGroup";
import { useEffect, useState } from "react";
import { kwaFormat, processStateToNum } from "../../utils/UtilsFunc";
import Timeline from "./Timeline";

type ProgressStatus = {
  status: string;
  message: string;
};

const OrderInfo = (props: any) => {
  const { userInfo, navigate } = props;

  const [project, setProject] = useState<any | null>(null);
  const [subscription, setSubscription] = useState<any | null>(null);
  const [delivery, setDelivery] = useState<any | null>(null);
  const [progress, setProgress] = useState<any | null>(null);

  useEffect(() => {
    if (!userInfo || Object.keys(userInfo).length === 0) return;

    setSubscription(userInfo?.membership?.subscription || null);
    setProject(userInfo?.project || null);
    setDelivery(userInfo?.delivery || null);
    setProgress(userInfo?.progress || null);
  }, [userInfo]);

  return (
    <>
      <div className={`sec sec_2`} id={`order_info`}>
        <h3 className={`tit h3`}>이용중인 상품</h3>

        {!subscription && (
          <div className={`card_layout`}>
            <div className={`card_sec`}>
              <p className={`text-center body1_sb`}>이용중인 상품이 없습니다</p>
            </div>
          </div>
        )}

        {subscription && (
          <div className={`card_layout`}>
            <div className={`card_sec`}>
              <h3 className={`h3 icons proc`}>상품정보</h3>
              {/**---------------------상품정보------------------**/}
              <FormGroup>
                <FormGroup.Label>상품명</FormGroup.Label>
                <FormGroup.Value>{subscription?.plan?.name}</FormGroup.Value>
              </FormGroup>
              <FormGroup>
                <FormGroup.Label>등록일</FormGroup.Label>
                <FormGroup.Value>
                  {subscription?.plan?.start_at}
                </FormGroup.Value>
              </FormGroup>
              <FormGroup>
                <FormGroup.Label className={`icons tip`}>
                  만료일
                  <div className={`tooltip`}>
                    만료일 전까지 꼭 인터뷰를 완료하고 전자책 신청 및<br />
                    실물책 인쇄 신청(일부 상품만 해당)을 해주세요.
                    <br />
                    기간 만료시 진행 여부와 무관하게 상품이 만료됩니다.
                  </div>
                </FormGroup.Label>
                <FormGroup.Value className={`flex flex-wrap justify-end`}>
                  {subscription?.plan?.expire_at}
                  {subscription?.plan?.expire_at && (
                    <span className={`sp-primary`}>
                      남은 이용일
                      {parseInt(subscription?.plan?.remain_days) + 1}일
                    </span>
                  )}
                </FormGroup.Value>
              </FormGroup>

              {/**---------------------에피소드 진행률------------------**/}
              <FormGroup>
                <FormGroup.Label>에피소드 진행률</FormGroup.Label>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1px",
                    alignItems: "flex-end",
                  }}
                >
                  <FormGroup.Value>
                    <span>
                      <strong className={`point`}>
                        {progress?.total_episodes_count}
                      </strong>
                      {"개 중에 "}
                      <strong className={`point`}>
                        {progress?.complete_episodes_count}
                      </strong>
                      {"개 완료"}
                    </span>
                  </FormGroup.Value>
                </div>
              </FormGroup>

              {/**---------------------진행 상태------------------**/}
              <FormGroup>
                <FormGroup.Label>진행 상태</FormGroup.Label>
                <FormGroup.Value>
                  {/*pc 레이아웃*/}
                  <div className={`max-md:hidden`}>
                    <Timeline currentStatus={progress?.message} />
                  </div>
                  {/*모바일 레이아웃*/}
                  <div className={`md:hidden`}>
                    <span className={`sp-primary`}>
                      {processStateToNum(progress?.message)}
                    </span>
                  </div>
                </FormGroup.Value>
              </FormGroup>
            </div>

            {delivery && (
              <div className={`card_sec deli`}>
                <h3 className={`h3 icons deli`}>배송정보</h3>
                {/**---------------------배송정보------------------**/}
                <FormGroup>
                  <FormGroup.Label>수령인</FormGroup.Label>
                  <FormGroup.Value>{delivery?.recipient_name}</FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>배송지</FormGroup.Label>
                  <FormGroup.Value>
                    {delivery?.postal_code} {delivery?.address}
                    <br />
                    {delivery?.address_detail}
                  </FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>휴대폰 번호</FormGroup.Label>
                  <FormGroup.Value>{delivery?.recipient_phone}</FormGroup.Value>
                </FormGroup>
                {delivery?.tracking_number && (
                  <FormGroup>
                    <FormGroup.Label>운송장 번호</FormGroup.Label>
                    <FormGroup.Value>
                      {delivery?.tracking_number}
                      <button className={`btn_copy`}>복사</button>
                    </FormGroup.Value>
                  </FormGroup>
                )}
                {delivery?.created_at && (
                  <FormGroup>
                    <FormGroup.Label>수정일</FormGroup.Label>
                    <FormGroup.Value>
                      주문일: {delivery?.created_at}{" "}
                      {delivery?.updated_at
                        ? ", 수정일: " + delivery?.updated_at
                        : ""}
                    </FormGroup.Value>
                  </FormGroup>
                )}
              </div>
            )}

            {subscription?.payment && (
              <div className={`card_sec`}>
                <h3 className={`h3 icons pay`}>결제 정보</h3>
                {/**---------------------결제 정보------------------**/}
                {/*본인 결제일경우*/}
                <FormGroup>
                  <FormGroup.Label>결제 번호</FormGroup.Label>
                  <FormGroup.Value>
                    {subscription?.payment?.payment_number}
                  </FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>결제일</FormGroup.Label>
                  <FormGroup.Value>
                    {subscription?.payment?.payment_at}
                  </FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>결제 금액</FormGroup.Label>
                  <FormGroup.Value>
                    {kwaFormat(subscription?.payment?.payment_amount)} 원
                  </FormGroup.Value>
                </FormGroup>
                <FormGroup>
                  <FormGroup.Label>결제 수단</FormGroup.Label>
                  <FormGroup.Value>
                    {subscription?.payment?.payment_method}
                  </FormGroup.Value>
                </FormGroup>
                {/*쿠폰입력한 정보일경우*/}
                {/*<p className={`text-center body1_sb`}>선물받은 상품이에요!</p>*/}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default OrderInfo;
